import React from 'react';
import styles from './shSection.module.scss';

import PropTypes from 'prop-types';

const ShSection = ( {
                        ypadding = "both",
                        variant = "transparent",
                        className = '',
                        children,
                        id =""
                    } ) => {

   return <div className={ styles.shSection + ' ' + className + " " + styles[variant]+ " " + styles[ypadding]} id={id}>
       <div className="container">
           <div className="row mx-auto">
               {children}
           </div>
        </div>
   </div>

};

export default ShSection;

ShSection.propTypes = {
    variant: PropTypes.oneOf(
        [ "primary", "dark", "dark-00", "cream-01", "cream-02", "sepia", "transparent" ]
    ),
    ypadding: PropTypes.oneOf(
        [ "none", "top", "bottom", "both", "both-small" ]
    )
}
